import React from 'react';

/**
 * Renders a project card component.
 *
 * @param {Object} props - The props object containing the project details.
 * @param {string} props.imagesrc - The source URL of the project image.
 * @param {string} props.projectTitle - The title of the project.
 * @param {string} props.projectDesc - The description of the project.
 * @returns {JSX.Element} The rendered project card component.
 */
export default function ProjectCard (props){

    return(

        <div className='bg-white rounded-lg overflow-hidden'>
            <img className='w-full h-56 object-cover shadow-lg' alt={"Project image"} src={props.imagesrc}></img>
            <div className='p-4'>
                <h3 className='text-lg font-semibold text-black'>{props.projectTitle}</h3>
                <p className='text-black'>{props.projectDesc}</p>
                <button className='mt-2 bg-blue-500 hober:bg-blue-700 text-white font-bold py-2 px-4 rounded'>
                    <a href={props.link} target='_blank'>View Details</a>
                </button>
            </div>
        </div>

    )

}